import { render, staticRenderFns } from "./Submitter.vue?vue&type=template&id=4d66d539"
import script from "./Submitter.vue?vue&type=script&lang=js"
export * from "./Submitter.vue?vue&type=script&lang=js"
import style0 from "./Submitter.vue?vue&type=style&index=0&id=4d66d539&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports